import { createReducer } from 'redux-act'

const reducer = createReducer(
  {
    SHOW_NOTIFICATION: (state, payload) => (
      { ...state, cancel: false, ...payload, show: true, }
    ),
    HIDE_NOTIFICATION: (state, payload) => (
      { show: false, status: state.status }
    ),
  }, { show: false }
)

export default reducer



// WEBPACK FOOTER //
// ./src/reducers/notification.js